var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0077FF",
    d: "M0,54V18C0,8.1,8.1,0,18,0h36c9.9,0,18,8.1,18,18v36c0,9.9-8.1,18-18,18H18C8.1,72,0,63.9,0,54z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M37.9,49C23.3,49,15,39.2,14.7,23H22c0.2,11.9,5.6,16.9,9.9,18V23h6.9v10.3c4.2-0.4,8.6-5.1,10.1-10.3h6.9 c-1.1,6.3-5.9,11-9.3,12.9c3.4,1.6,8.9,5.6,10.9,13h-7.6c-1.6-4.9-5.7-8.8-11-9.3V49H37.9L37.9,49z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.525848587d5449f3925970096e959304.svg";
export { ForwardRef as ReactComponent };